"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _config = _interopRequireDefault(require("../config"));
var _FullPageSpinner = _interopRequireDefault(require("../components/common/FullPageSpinner/FullPageSpinner"));
var _path = _interopRequireDefault(require("../helpers/path"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function forVerified(WrappedComponent) {
  var ModifiedComponent = function ModifiedComponent(props) {
    var pending = props.pending,
      verificationLevel = props.verificationLevel;
    if (pending) {
      return /*#__PURE__*/_react["default"].createElement(_FullPageSpinner["default"], null);
    }
    if (verificationLevel < _config["default"].KYC.MinimumVerificationLevel && _config["default"].KYC.UpfrontKYC) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: (0, _path["default"])('/standalonekyc')
      });
    }
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
  };
  var mapStateToProps = function mapStateToProps(state) {
    return {
      verificationLevel: state.user.accounts.length ? state.user.accounts[0].VerificationLevel : 0,
      pending: state.user.userInfo === undefined
    };
  };
  return (0, _reactRedux.connect)(mapStateToProps)(ModifiedComponent);
}
var _default = exports["default"] = forVerified;